import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import injectSheet from 'react-jss';

function AlternateField({ classes, visible, children }) {
  return React.cloneElement(children, {
    className: classNames(children.props.className, classes.root, visible && classes.visible),
    tabIndex: visible ? undefined : -1,
  });
}

AlternateField.propTypes = {
  classes: PropTypes.object.isRequired,
  visible: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
};

const styles = theme => ({
  root: {
    opacity: 0,
    transform: `translateX(${-theme.spacing.xsmall}px)`,
    transition: theme.transitions.create(['opacity', 'transform']),
    pointerEvents: 'none',
    '&:not(:first-child)': {
      position: 'absolute',
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
    },
  },
  visible: {
    opacity: 1,
    transform: 'translateX(0)',
    transitionDelay: theme.transitions.duration.shortest,
    pointerEvents: 'initial',
  },
});

export default injectSheet(styles)(AlternateField);



// WEBPACK FOOTER //
// ./src/site-render/src/RegisterExtension/AlternateField/AlternateField.js